import React, { useState } from 'react';
import { CouponsContainer } from '../../CouponsContainer';
import { TITLE_APPLIED_COUPONS, TITLE_MINI } from '../../CouponsContainer/constants';
import { styles } from './CartCoupons.css';
import { Arrow } from '@jbhi-fi/lanyard-ui/components/Icons';
import Alert from '@jbhi-fi/lanyard-ui/components/Alert';
import { Coupon } from '../../types';

export type CartCouponsProps = {
  variant?: 'default' | 'cart'; // this can be updated when new cart is completed
  coupons: Array<Coupon>;
  manuallyAppliedCoupons: Array<Coupon>;
  shouldShowAvailableCoupons: boolean;
  isLoggedIn: boolean;
  handleSelectCoupon: (couponCode: string) => void;
  handleRemoveCoupon: (couponCode: string, isCart?: boolean) => void;
  handleAddCoupon: (couponCode: string) => void;
  handleDeselectCoupon?: () => void;
};
export const CartCoupons = ({
  variant = 'default',
  shouldShowAvailableCoupons,
  coupons,
  manuallyAppliedCoupons,
  handleSelectCoupon,
  handleRemoveCoupon,
  handleAddCoupon,
  handleDeselectCoupon,
}: CartCouponsProps) => {
  const invalidCoupons = [
    ...coupons.filter(coupon => coupon.isApplied && !coupon.success),
    ...manuallyAppliedCoupons.filter(coupon => !coupon.success),
  ];
  const appliedCoupons = [
    ...coupons.filter(coupon => coupon.isApplied).sort((a, b) => (b.success ? 1 : 0) - (a.success ? 1 : 0)),
    ...manuallyAppliedCoupons.filter(coupon => coupon.success),
  ];

  const availableCoupons = coupons.filter(coupon => !coupon.isApplied);
  const [isCouponsContainerOpen, setIsCouponsContainerOpen] = useState(true);
  const [couponValue, setCouponValue] = useState('');
  const handleCollapse = () => {
    setIsCouponsContainerOpen(!isCouponsContainerOpen);
  };

  const clearCouponInput = (message: string) => {
    setCouponValue('');
    alert(message);
    handleDeselectCoupon?.();
  };

  const handleCouponAdd = () => {
    const coupon = couponValue.trim().replace('#', '').toUpperCase();
    if (!coupon) {
      clearCouponInput('Please enter a valid coupon');
      return;
    }
    let isCouponApplied = false;
    isCouponApplied = appliedCoupons.some(appliedCoupon => appliedCoupon.couponCode === coupon);
    if (isCouponApplied) {
      clearCouponInput(`The coupon code ${coupon} has already been added to your order`);
      return;
    }

    handleAddCoupon(coupon);
  };

  const handleCouponChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCouponValue(value);
  };

  return (
    <>
      {variant === 'cart' ? (
        <>
          <div className={styles.inputWrapper}>
            <div className={styles.inputSection}>
              <input
                data-coupon-input
                data-testid="my-cart_coupon-code-input"
                placeholder="Coupon code"
                id="checkout_couponcode"
                className={styles.inputBox}
                size={20}
                type="text"
                required
                value={couponValue}
                onChange={e => handleCouponChange(e)}
              />
            </div>
            <button className={styles.couponsButton} onClick={handleCouponAdd}>
              <span className="btn__content visually-hidden-on-mobile">Apply</span>
              <i className="btn__spinner icon icon--button-spinner"></i>
            </button>
          </div>
        </>
      ) : null}

      <div className={`CartCoupons ${styles.container}`}>
        {invalidCoupons?.length ? (
          <Alert classes={styles.alert} showIcon type="warning" heading=" Your applied coupons are not eligible" />
        ) : null}
        {appliedCoupons.length > 0 ? (
          <div className={styles.couponsContainer}>
            <div className={styles.title}>{TITLE_APPLIED_COUPONS}</div>
            <CouponsContainer
              variant="mini"
              coupons={appliedCoupons}
              shouldShowSubheading={false}
              onApplyCoupon={handleSelectCoupon}
              onRemoveCoupon={handleRemoveCoupon}
              viewLimit={Infinity}
            />
          </div>
        ) : null}
        {availableCoupons.length > 0 && shouldShowAvailableCoupons ? (
          <div className={styles.couponsContainer}>
            <div className={styles.titleContainer}>
              <span className={styles.title}>{TITLE_MINI}</span>
              <Arrow className={styles.icon({ isOpen: isCouponsContainerOpen })} onClick={handleCollapse} />
            </div>
            {isCouponsContainerOpen ? (
              <CouponsContainer
                variant="mini"
                coupons={availableCoupons}
                shouldShowSubheading={false}
                onApplyCoupon={handleSelectCoupon}
                onRemoveCoupon={handleRemoveCoupon}
              />
            ) : null}
          </div>
        ) : null}
      </div>
    </>
  );
};
